import Type from "./Type";

export default class Item {
    constructor(
        public readonly id: string,
        public readonly text: string,
        public readonly type: Type[]|Type,
    ) {
    }
}